module.exports = __webpack_public_path__ + "static/ocorie-srv-splash-cert-img-773818c926f0f33295b1bbeaa1fc73bf.png";